// extracted by mini-css-extract-plugin
export default {"container":"BestPriceChart_container__n8kcK","title-wrapper":"BestPriceChart_title-wrapper__4DL1i","title":"BestPriceChart_title__cmXud","subtitle":"BestPriceChart_subtitle__o1rsf"};